<template lang="html">
  <section class="aligned-territories-container">
    <div class="field-container">
      <label class="query-label">
        {{$t("includeChildTerritories")}}
      </label>
      <div class="selection">
        {{getChildTerritories}}
      </div>
    </div>
  </section>
</template>

<script>
  import { mapState } from "vuex";

  export default {
    name: "aligned-territories-container",
    props: {
      deId: String,
      appId: String
    },
    computed: {
      ...mapState({
        apps: "apps",
        messages: "messages"
      }),
      app() {
        return this.apps.find(app => app.uuid === this.appId);
      },
      de() {
        return this.app.dataElements[this.deId];
      },
      getChildTerritories() {
        return this.de.includeChildren;
      }
    }
  }
</script>

<style scoped lang="scss">
.aligned-territories-container {
  .field-container {
    display: flex;
    flex-basis: 100%;
    .query-label {
      font-size: 0.85rem;
      font-weight: bold;
      flex-basis: 15%;
    }
    .selection {
      display: inline-block;
    }
  }
}
</style>
